import { createTheme, Theme } from "@mui/material/styles";

// assets
import colors from "themes/_themes-vars.module.scss";
import { THEME_CONFIG } from "config/app";

// project imports
import componentStyleOverrides from "./compStyleOverride";
import themePalette from "./palette";
import themeTypography from "./typography";

interface ThemeColors {
  [key: string]: string;
}

interface Customization {
  navType?: string;
  fontFamily?: string;
  borderRadius?: number;
}

interface ThemeOption {
  colors: ThemeColors;
  heading: string;
  paper: string;
  backgroundDefault: string;
  background: string;
  darkTextPrimary: string;
  darkTextSecondary: string;
  textDark: string;
  menuSelected: string;
  menuSelectedBack: string;
  divider: string;
  grey500: string;
  customization: Customization;
}

/**
 * Represent theme style and structure as per Material-UI
 * @param customization customization parameter object
 */

export const theme = (customization: Customization): Theme => {
  const color = colors as ThemeColors;

  const themeOption: ThemeOption = {
    colors: color,
    heading: color.grey900,
    paper: color.paper,
    backgroundDefault: color.paper,
    background: color.primaryLight,
    darkTextPrimary: color.grey700,
    darkTextSecondary: color.grey500,
    textDark: color.grey900,
    menuSelected: color.secondaryDark,
    menuSelectedBack: color.secondaryLight,
    divider: color.grey200,
    grey500: color.grey500,
    customization,
  };

  const themeOptions = {
    direction: "ltr" as const,
    palette: themePalette(themeOption),
    mixins: {
      toolbar: {
        // marginTop offsets the status bar; the AppBar bg fills that region.
        // minHeight is a floor -- the header's real height is driven by its
        // tallest child (the ~76px avatar block) and is constant across pages
        // now that the supporter ring no longer toggles. In the in-flow flex
        // shell nothing measures the header, so it needn't be hard-pinned.
        marginTop: THEME_CONFIG.nativeStatusBarHeight,
        minHeight:
          THEME_CONFIG.toolbarHeight - THEME_CONFIG.nativeStatusBarHeight,
        "@media (min-width: 600px)": {
          minHeight:
            THEME_CONFIG.toolbarHeight - THEME_CONFIG.nativeStatusBarHeight,
        },
      },
    },
    typography: themeTypography(themeOption),
  };

  const themes = createTheme(themeOptions as any);
  themes.components = componentStyleOverrides(themeOption);

  return themes;
};

export default theme;
